import { appGetState } from 'legacy/lut/store'

import { getTokens } from 'core/classes/helpers/StorageHelper'
import { proxy } from 'core/classes/helpers/UrlHelper'
import { HttpHeaders, Rest } from 'core/classes/http'

import {
  IFetchGlobalPartnerDetailsParameters,
  IFetchGlobalPartnerDetailsResult,
} from '../models/fetchGlobalPartnerDetails'

export const fetchGlobalPartnerDetails = async (filter: IFetchGlobalPartnerDetailsParameters) => {
  const url = proxy(`/webservice/197/sp/v4/spJBPGlobalPartnersDetailsByGeo/call`)
  const payload = {
    'p.Filters': JSON.stringify({
      GlobalPartnerId: filter.globalPartnerId,
      Pbms: filter.pbmFilter,
      Geo: filter.geoMappingsFilter,
      Products: filter.productTreeFilter,
      PartnerIds: filter.partnerIdFilter,
      Managers: filter.managerFilter,
    }),
  }
  const {
    app: { ownerId },
  } = appGetState()
  const [accessToken] = getTokens(ownerId)

  const headers = new HttpHeaders()
  if (accessToken) {
    headers.add('Authorization', `Bearer ${accessToken}`)
  }

  try {
    const response: IFetchGlobalPartnerDetailsResult = await Rest.post({
      url,
      payload,
      headers,
    })

    return {
      Data: response.Data.map((original, i, arr) => ({
        ...original,
        hasChildren: arr.some((it) => it.ParentId === original.EntryId),
      })),
    }
  } catch (e) {
    return {
      Data: [],
    }
  }
}
